<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M20.7309 4.26911C19.2054 2.74363 16.7321 2.74363 15.2066 4.26911L10.5191 8.95661C8.99363 10.4821 8.99363 12.9554 10.5191 14.4809C10.8429 14.8047 11.2081 15.0589 11.5969 15.2446C11.9862 15.4306 12.1511 15.897 11.9651 16.2863C11.7791 16.6757 11.3127 16.8405 10.9234 16.6545C10.3768 16.3934 9.86524 16.0367 9.41426 15.5857C7.27858 13.4501 7.27858 9.98744 9.41426 7.85176L14.1018 3.16426C16.2374 1.02858 19.7001 1.02858 21.8357 3.16426C23.9714 5.29994 23.9714 8.76256 21.8357 10.8982L20.0056 12.7284C19.7005 13.0335 19.2058 13.0335 18.9007 12.7284C18.5956 12.4233 18.5956 11.9287 18.9007 11.6236L20.7309 9.79339C22.2564 8.2679 22.2564 5.7946 20.7309 4.26911ZM13.0349 8.71368C13.2209 8.32435 13.6873 8.15951 14.0766 8.34549C14.6232 8.60662 15.1348 8.96328 15.5857 9.41426C17.7214 11.5499 17.7214 15.0126 15.5857 17.1482L10.8982 21.8357C8.76256 23.9714 5.29994 23.9714 3.16426 21.8357C1.02858 19.7001 1.02858 16.2374 3.16426 14.1018L4.99444 12.2716C5.29953 11.9665 5.79419 11.9665 6.09929 12.2716C6.40439 12.5767 6.40439 13.0713 6.09929 13.3764L4.26911 15.2066C2.74363 16.7321 2.74363 19.2054 4.26911 20.7309C5.7946 22.2564 8.2679 22.2564 9.79339 20.7309L14.4809 16.0434C16.0064 14.5179 16.0064 12.0446 14.4809 10.5191C14.1571 10.1953 13.7919 9.94112 13.4031 9.75538C13.0138 9.5694 12.8489 9.10301 13.0349 8.71368Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgLink',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
